import React from 'react';
import { useTranslation } from 'react-i18next';
import { insertOrganizationsUser, removeOrganizationsUser } from '../../../../services/organizations';
import { Select, MenuItem } from '@material-ui/core';
import { RemoteTable } from '../../../../shared/components';
import { listUserOrganizations } from '../../../../services/user';
import { PersonIcons } from '../../../../shared/MaterialIcons';

export const OrgsTable = ({ setMessage, data: userData, setOrgsCount }) => {
  const { t: translate } = useTranslation();

  const localization = {
    body: {
      editRow: {
        deleteText: translate('remove organization')
      },
      addTooltip: translate('add organization'),
      deleteTooltip: translate('remove organization')
    }
  };

  const errorMessage = (error, serviceName) => {
    const response = error.response.data.error || error;
    switch (response.message) {
    case 'Organization user already exists':
      return setMessage(translate('User already in organization'));
    case 'Invalid parameters provided':
      return setMessage(translate('This organizationId doesnt exist'));
    default:
      return setMessage(translate(`NOT ${serviceName} user`));
    }
  };

  const updateData = async (serviceName, service, newData) => {
    try {
      const orgId = newData.organization.id;
      const role = newData.role || 'VIEWER';
      const { id: userId } = userData;

      if (serviceName === 'inserted') {
        await service(orgId, userId, role);
      } else {
        await service(orgId, userId);
      }

      return setMessage(translate(`${serviceName} user`));
    } catch (error) {
      errorMessage(error, serviceName);
    }
  };

  const editable = {
    onRowAdd: async (newData) => {
      return updateData('inserted', insertOrganizationsUser, newData);
    },
    onRowDelete: (oldData) => {
      return updateData('removed', removeOrganizationsUser, oldData);
    }
  };

  const columns = [
    { title: 'OrganizationId', field: 'organization.id' },
    { title: translate('name'), field: 'organization.name', editable: 'never' },
    {
      title: translate('role'),
      field: 'role',
      editComponent: (props) => (
        <Select
          value={props.value || 'VIEWER'}
          onChange={(e) => props.onChange(e.target.value)}
        >
          <MenuItem value="EDITOR">EDITOR</MenuItem>
          <MenuItem value="VIEWER">VIEWER</MenuItem>
        </Select>
      )
    },
    {
      title: translate('type'),
      field: 'organization.type',
      editable: 'never'
    }
  ];

  const searchUserOrganizations = async (offset, limit, search, count) => {
    const { data: response } = await listUserOrganizations({ userId: userData.id, offset, limit, search, count, populate: 'organization' });
    return response;
  };

  return (
    <>
      <RemoteTable
        setMessage={setMessage}
        dataService={searchUserOrganizations}
        columns={columns}
        editable={editable}
        icons={PersonIcons}
        localization={localization}
        setTotalCount={setOrgsCount}
      />
    </>
  );
};

export default OrgsTable;
